import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import AccessSection from "@/pages/home/components/AccessSection";
import DownloadSection from "@/pages/home/components/DownloadSection";
import AddressSection from "@/pages/home/components/AddressSection";
import ComicSection from "@/pages/home/components/ComicSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SafetySection from "@/pages/home/components/SafetySection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <AccessSection />
        <DownloadSection />
        <AddressSection />
        <ComicSection />
        <GuideSection />
        <FaqSection />
        <SafetySection />
      </main>
      <Footer />
    </div>
  );
}